function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { useOptionalUser } from '@adsk/alloy-provider';
import TopNavigation from '@adsk/alloy-top-navigation';

/**
 * This component renders TopNavigation based on optional user - means the user can be logged in or logged out.
 *
 * @param onLogout
 * @return {*}
 * @constructor
 */
const ConnectedTopNavigationOptionalUser = _ref => {
  let {
    onLogout
  } = _ref;
  const {
    data: user,
    loading
  } = useOptionalUser();
  const extraProps = {};
  if (loading || user) {
    extraProps.user = user;
  }
  return /*#__PURE__*/React.createElement(TopNavigation, _extends({
    logo: true,
    login: true,
    isProductRequired: true,
    onLogout: onLogout,
    showSubscriptionsModal: true
  }, extraProps));
};
ConnectedTopNavigationOptionalUser.propTypes = {
  /** callback called on logout */
  onLogout: PropTypes.func
};
export default ConnectedTopNavigationOptionalUser;
//# sourceMappingURL=ConnectedTopNavigationOptionalUser.js.map